import {http} from "@/plugins/axios"
//import axios from 'axios'
//import authHeader from '@/auth/auth-header'
import Documento from "@/model/documento"

//export default function() {

    function downloadArquivo(id) {
        return http({
            url: `/documento/${id}/pdf`,
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement('a');

            var header = (response.headers['content-disposition'])
            const indexOfInicio = header.indexOf("filename=");
            var filename = header.slice(indexOfInicio + 9);

            fileLink.href = fileURL;
            fileLink.setAttribute('download', filename);
            document.body.appendChild(fileLink);

            fileLink.click();
        });
    }

    // anexa (ou substitui) o PDF de um documento já salvo; devolve o documento atualizado
    function enviarArquivo(id, arquivo) {
        const formData = new FormData();
        formData.append("arquivo", arquivo);
        return http
            .post(`/documento/${id}/arquivo`, formData)
            .then(res => Documento(res.data));
    }

    function buscarDocumento(id) {

        return http
            .get(`/documento/${id}`)
            .then(res => Documento(res.data))
            .catch((e) => {
                console.log(e);
            });
    }

    function buscarDocumentoFiltro(filtro) {
        return http
            .get("/documento/filtro", {
                params: {
                    numero: filtro.numero,
                    ano: filtro.ano,
                    ementa: filtro.ementa,
                    tipoDocumentoId: filtro.tipoDocumentoId,
                    destino: filtro.destino,
                    status: filtro.status,
                    isLegislacao: filtro.isLegislacao,
                    isDeliberacao: filtro.isDeliberacao
                }
            })
            .then(res => res.data || [])
            .catch((err) => {
                // 404 = sem resultado; outras falhas propagam
                if (err.response && err.response.status === 404) {
                    return [];
                }
                throw err;
              });
    }

    function buscarDocumentoFiltroPaginado(filtro, page, size) {
        return http
            .get("/documento/filtro/page", {
                params: {
                    numero: filtro.numero,
                    ano: filtro.ano,
                    ementa: filtro.ementa,
                    tipoDocumentoId: filtro.tipoDocumentoId,
                    destino: filtro.destino,
                    status: filtro.status,
                    isLegislacao: filtro.isLegislacao,
                    isDeliberacao: filtro.isDeliberacao,
                    page: page,
                    size: size
                }
            })
            .then(res => res.data)
            .catch((err) => {
                console.error(err.response);
                return { content: [], totalElements: 0 };
            });
    }

    function buscarTipoDocumento(id){
        return http
            .get(`/tiposdocumento/${id}`)
            .then(res => res.data)
            .catch((e) => {
                console.log(e);
                return {tipoDocumentoId: null, nome: ""}
            });
    }
    function findTiposDocumento() {
        return http
            .get("/tiposdocumento")
            .then((response) => response.data)
            .catch((e) => {
                console.log(e);
            });
    }

    function findTiposLegislacao() {
        return http
            .get("/tiposdocumento/legislacao")
            .then((response) => response.data)
            .catch((e) => {
                console.log(e);
            });
    }

    function findTiposDeliberacao() {
        return http
            .get("/tiposdocumento/deliberacao")
            .then((response) => response.data)
            .catch((e) => {
                console.log(e);
            });
    }

    function salvar(documento) {
        if (documento.documentoId == null) {
            //post
            return http
                .post("/documento/", documento)
                .then((response) => Documento(response.data))
                .catch(err => {console.error(err.message);
                                throw err;                
                });
        } else {
            //put
            return http
                .put(`/documento/${documento.documentoId}`, documento)
                .then(response => Documento(response.data))
                .catch(err => console.error(err.message));
        }
    }

    function excluir(id){
        return http
            .delete(`/documento/${id}`)
            .then(res => {
                if(res.status === 204){
                    alert("Registro excluído com sucesso.")
                    return "ok"
                }
            })
            .catch((e) => {
                console.log(e);
                alert("Não foi possivel excluir o item " + id);
                return "erro"
            });
    }

    let service = {}

    service.salvar = salvar
    service.excluir = excluir
    service.findTiposDocumento = findTiposDocumento
    service.buscarTipoDocumento = buscarTipoDocumento
    service.findTiposLegislacao = findTiposLegislacao
    service.findTiposDeliberacao = findTiposDeliberacao

    service.buscarDocumento = buscarDocumento
    service.buscarDocumentoFiltro = buscarDocumentoFiltro
    service.buscarDocumentoFiltroPaginado = buscarDocumentoFiltroPaginado
    service.downloadArquivo = downloadArquivo
    service.enviarArquivo = enviarArquivo
    

    export default service
//}